import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import ISIMCodeValidatorRecord from './data/ISIMCodeValidatorRecord';
import ISIMCodeValidatorConstants from './constants';

function getInitialState() {
  return new ISIMCodeValidatorRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<ISIMCodeValidatorRecord> = (state = defaultState, action) => {
  switch (action.type) {
    case ISIMCodeValidatorConstants.VALIDATE_CODE_REQUEST:
      return state.set('isLoading', true);

    case ISIMCodeValidatorConstants.VALIDATE_CODE_REQUEST_SUCCESS:
      return state.merge({
        isLoading: false,
        isFinished: true,
      });

    case ISIMCodeValidatorConstants.VALIDATE_CODE_REQUEST_ERROR:
      return state.merge({
        isLoading: false,
        isFinished: false,
        error: new ErrorRecord(
          typeof action.error === 'object' && action.error !== null ? action.error : undefined
        ),
      });

    default:
      return state;
  }
};

export default reducer;
